import { render, staticRenderFns } from "./editacc.vue?vue&type=template&id=f36a6768&scoped=true&"
import script from "./editacc.vue?vue&type=script&lang=js&"
export * from "./editacc.vue?vue&type=script&lang=js&"
import style0 from "./editacc.vue?vue&type=style&index=0&id=f36a6768&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36a6768",
  null
  
)

export default component.exports